import {
    FETCH_DASHBOARD_CONVERSIONS,
    SET_SELECTED_CONVERSION
} from '../actions/actionTypes';

const initialState = {
    k2aConversions:     [],
    customConversions:  [],
    selectedConversion: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_CONVERSIONS:
            return {
                ...state,
                k2aConversions:    [...action.payload.k2a],
                customConversions: [...action.payload.custom]
            };
        case SET_SELECTED_CONVERSION:
            return {
                ...state,
                selectedConversion: { ...action.payload }
            };
        default:
            return state;
    }
};
